package ai.flowstorm.studio.ui

import ai.flowstorm.common.ui.EntityTable
import ai.flowstorm.studio.model.GeneratedSample
import ai.flowstorm.studio.resources.GeneratedSampleResource
import ai.flowstorm.studio.ui.data.GeneratedSampleForm
import io.kvision.i18n.tr
import io.kvision.modal.ModalSize
import io.kvision.tabulator.ColumnDefinition
import io.kvision.tabulator.Layout
import io.kvision.tabulator.TabulatorOptions
import io.kvision.utils.obj
import ai.flowstorm.common.setProperty
import ai.flowstorm.studio.ui.data.GeneratedSampleViewer
import io.kvision.utils.px


class GeneratedSampleTable(
    splitMode: Boolean = true, hideHeader: Boolean = false, className: String? = "content-panel"
) : EntityTable<GeneratedSample>(
    caption = "Generated Sample",
    model = GeneratedSampleResource,
    tabulatorOptions = TabulatorOptions(
        layout = Layout.FITCOLUMNS,
        columns = listOf(
            ColumnDefinition(tr("Time"), GeneratedSample::timeAsString.name, width = "30%"),
            ColumnDefinition(tr("Service"), GeneratedSample::serviceName.name, width = "15%"),
            ColumnDefinition(tr("Model"), GeneratedSample::modelId.name, width = "20%"),
            ColumnDefinition(tr("Duration"), GeneratedSample::elapsedTime.name, width = "15%"),
            ColumnDefinition(tr("Task"), GeneratedSample::taskName.name, width = "20%"),
        )
    ),
    dataExtractor = {
        obj {
            setProperty(this, it::timeAsString)
            setProperty(this, it::serviceName)
            setProperty(this, it::modelId)
            setProperty(this, it::elapsedTime)
            setProperty(this, it::taskName)
        }
    },
    entityComponentFactory = { GeneratedSampleViewer(GeneratedSampleResource) },
    deleteEnabled = false,
    saveEnabled = false,
    modalSize = ModalSize.XLARGE,
    hideHeader = hideHeader,
    className = className,
    splitMode = splitMode,
    tabWidth = 700.px,
    searchEnabled = true
)
